export default __webpack_public_path__ + "static/media/paste-black-icon.ac35077b.svg";